import React from 'react';
import {navigateToRequirements} from './college-status-text';
import {PartnerCollegeProfile} from './credit-hours-status-text';

interface Props {
  collegeProfile: PartnerCollegeProfile & {
    userInfo: {
      highSchoolInfo: {
        senior: boolean;
      };
    };
  };
  missingCredits: number;
}

const CourseCreditStatusText = ({
  missingCredits,
  collegeProfile: {
    college: {
      earningRelationship: {statusType},
      partnerApplicationDeadlineMonth,
      partnerApplicationDeadlineDay,
      partnerSubmissionDeadlineMonth,
      partnerSubmissionDeadlineDay,
      useApplyByTerminology,
    },
    userInfo: {
      highSchoolInfo: {senior},
    },
  },
}: Props) => {
  const applicationDeadlineMonth =
    partnerApplicationDeadlineMonth !== undefined
      ? Number(partnerApplicationDeadlineMonth) + 1
      : undefined;
  const submissionDeadlineMonth =
    partnerSubmissionDeadlineMonth !== undefined
      ? Number(partnerSubmissionDeadlineMonth) + 1
      : undefined;

  switch (statusType) {
    case 'deadline_passed':
      return (
        <p className="college-profile-progress-card-warning-status">
          {`You didn't meet this college's earnings deadline,
            so your earnings are not guaranteed.`}
        </p>
      );
    case 'submitted':
      return (
        <div>
          <p className="college-profile-progress-card-positive-status">
            {`Way to go! Your earnings from this college are almost locked in. ${
              useApplyByTerminology ? 'Apply' : 'Be admitted'
            } by
                ${applicationDeadlineMonth}/${partnerApplicationDeadlineDay}, enroll, and `}
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                navigateToRequirements(false);
              }}
            >
              meet any additional requirements
            </a>
            {' set by the school (if needed) to be awarded.'}
          </p>
        </div>
      );
    case 'boost_gpa':
      return (
        <p className="college-profile-progress-card-no-status">
          {`Add classes as you go! At least ${missingCredits}
            more credits needed by senior year.`}
        </p>
      );
    case 'earning_deadline_soon': {
      if (missingCredits > 0) {
        return (
          <p className="college-profile-progress-card-warning-status">
            {`Add classes as you go! At least ${missingCredits} more course
              credits needed by ${submissionDeadlineMonth}/${partnerSubmissionDeadlineDay}.`}
          </p>
        );
      } else {
        return (
          <p className="college-profile-progress-card-positive-status">
            {`You've met the minimum 15 credits - be sure to add all
              your high school classes by ${submissionDeadlineMonth}/${partnerSubmissionDeadlineDay}.`}
          </p>
        );
      }
    }
    case 'earning': {
      if (missingCredits > 0) {
        if (senior) {
          return (
            <p className="college-profile-progress-card-no-status">
              {`Add classes as you go! At least ${missingCredits} more credits needed
                by ${submissionDeadlineMonth}/${partnerSubmissionDeadlineDay}.`}
            </p>
          );
        }
        return (
          <p className="college-profile-progress-card-no-status">
            {`Add classes as you go! At least ${missingCredits}
              more credits needed by senior year.`}
          </p>
        );
      } else {
        if (senior) {
          return (
            <p className="college-profile-progress-card-positive-status">
              {`You've met the minimum 15 credits - be sure to add all your high school classes
                by ${submissionDeadlineMonth}/${partnerSubmissionDeadlineDay}.`}
            </p>
          );
        } else {
          return (
            <p className="college-profile-progress-card-no-status">
              {`You've met the minimum 15 credits - be sure to add all
                 your high school classes.`}
            </p>
          );
        }
      }
    }
    default:
      return null;
  }
};

export default CourseCreditStatusText;
